import dayjs from 'dayjs';
import * as React from 'react';
import BCDateRangePicker, { RangePickerValue } from '../../../BCDateRangePicker';
import { findMessage } from '../../../BCIntl';
import { IPropertyComponentProps, IPropertyItem } from '../../entities';

const defaultStyle: React.CSSProperties = { width: '100%' };
const placeholder: [string, string] = [findMessage.get('100995'), findMessage.get('100996')];

const DateRangePickerProperty = (props: IPropertyComponentProps) => {
	const replaceValue = (item: IPropertyItem, newValue: any) => {
		props.onValueChanged(item, newValue);
	};

	const onChange = (dates: RangePickerValue) => {
		let startDate = null;
		let endDate = null;

		if (dates) {
			startDate = dates[0]
				.set('hour', 0)
				.set('minute', 0)
				.set('second', 0)
				.set('millisecond', 0)
				.format();
			endDate = dates[1]
				.set('hour', 0)
				.set('minute', 0)
				.set('second', 0)
				.set('millisecond', 0)
				.format();
		}

		props.customChangeEvent
			? props.customChangeEvent([startDate, endDate])
			: replaceValue(props.item, [startDate, endDate]);
	};

	const getDateValue = (value?: string) =>
		value ? dayjs(new Date(value), { format: props.item.options }) : null;

	const getValue = (): RangePickerValue => {
		if (props.value && Array.isArray(props.value)) {
			const startDate: string = props.value[0];
			const endDate: string = props.value[1];

			return [getDateValue(startDate), getDateValue(endDate)];
		} else {
			return [null, null];
		}
	};

	return (
		<BCDateRangePicker
			value={getValue()}
			placeholder={placeholder}
			onChange={onChange}
			{...(props.item.options ? { format: [props.item.options, props.item.options] } : {})}
			style={props.style || defaultStyle}
			disabled={props.item.disabled || props.item.readOnly}
			readOnly={props.readonly}
			allowClear
			size="small"
		/>
	);
};
export default DateRangePickerProperty;
